import { __decorate, __awaiter, __param } from 'tslib';
import { Injectable, Optional, SkipSelf, NgModule } from '@angular/core';
import { ErrorMessageService, BaseService, DocumentValidator, DateValidator, UiBsUtilModule } from '@wlp/ui-bs-util';
import { SpeJFundsProxy, ConfigService, SpeNAccountProxy, SpeJCashInProxy, SpeJCheckEventProxy, SpeViewNAccountProxy, SpeNAccountsProxy, UiPxCashInModule } from '@wlp/ui-px-cashin';
import { CommonModule } from '@angular/common';
import { FormControl, Validators, FormBuilder, FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { Storage, IonicStorageModule } from '@ionic/storage';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { APP_PARAMETER } from '@wlp/ui-bs-parameter';
import { BehaviorSubject } from 'rxjs';

let StatementService = class StatementService {
    constructor(speJFundsProxy, errorMessageService) {
        this.speJFundsProxy = speJFundsProxy;
        this.errorMessageService = errorMessageService;
    }
    getLatestTransaction(idWhiteLabel, uuidAccount, quantityItens) {
        return this.speJFundsProxy
            .getLatestTransaction(idWhiteLabel, uuidAccount, quantityItens)
            .toPromise();
    }
    getSumMoviments(idWhiteLabel, uuidAccount) {
        return this.speJFundsProxy
            .getSumMoviments(idWhiteLabel, uuidAccount, this.startDate(), this.endDate())
            .toPromise();
    }
    getErroMessage(err) {
        return this.errorMessageService.getError(err);
    }
    startDate() {
        let date = new Date(), dayF = '01', month = (date.getMonth() + 1).toString(), monthF = (month.length == 1) ? '0' + month : month, yearF = date.getFullYear();
        return yearF + '-' + monthF + '-' + dayF;
    }
    endDate() {
        let date = new Date(), day = date.getDate().toString(), dayF = (day.length == 1) ? '0' + day : day, month = (date.getMonth() + 1).toString(), monthF = (month.length == 1) ? '0' + month : month, yearF = date.getFullYear();
        return yearF + '-' + monthF + '-' + dayF;
    }
};
StatementService.ctorParameters = () => [
    { type: SpeJFundsProxy },
    { type: ErrorMessageService }
];
StatementService = __decorate([
    Injectable()
], StatementService);

let AccountBalanceService = class AccountBalanceService extends BaseService {
    constructor(storage, configService, speJFundsProxy, errorMessageService) {
        super(storage, configService);
        this.storage = storage;
        this.configService = configService;
        this.speJFundsProxy = speJFundsProxy;
        this.errorMessageService = errorMessageService;
        this.balance$ = new BehaviorSubject('');
    }
    getBalance(idWhiteLabel, uuidAccount) {
        return this.speJFundsProxy
            .getCheckBalance(idWhiteLabel, uuidAccount)
            .toPromise();
    }
    getBalanceSubject() {
        return this.balance$;
    }
    setBalanceSubject(data) {
        this.balance$.next(data);
    }
    getErroMessage(err) {
        return this.errorMessageService.getError(err);
    }
};
AccountBalanceService.ctorParameters = () => [
    { type: Storage },
    { type: ConfigService },
    { type: SpeJFundsProxy },
    { type: ErrorMessageService }
];
AccountBalanceService = __decorate([
    Injectable()
], AccountBalanceService);

let NotificationsService = class NotificationsService extends BaseService {
    constructor(speNAccountProxy, storage, configService, errorMessageService) {
        super(storage, configService);
        this.speNAccountProxy = speNAccountProxy;
        this.storage = storage;
        this.configService = configService;
        this.errorMessageService = errorMessageService;
        this.notificationTemplates = [
            {
                type: 1,
                title: "CASH_IN.NOTIFICATIONS.TEMPLATES.TED.TITLE",
                message: "CASH_IN.NOTIFICATIONS.TEMPLATES.TED.MESSAGE"
            },
            {
                type: 2,
                title: "CASH_IN.NOTIFICATIONS.TEMPLATES.ON_US.TITLE",
                message: "CASH_IN.NOTIFICATIONS.TEMPLATES.ON_US.MESSAGE"
            },
            {
                type: 3,
                title: "CASH_IN.NOTIFICATIONS.TEMPLATES.NEW_DEVICE.TITLE",
                message: "CASH_IN.NOTIFICATIONS.TEMPLATES.NEW_DEVICE.MESSAGE"
            },
            {
                type: 4,
                title: "CASH_IN.NOTIFICATIONS.TEMPLATES.CHANGE_DEVICE.TITLE",
                message: "CASH_IN.NOTIFICATIONS.TEMPLATES.CHANGE_DEVICE.MESSAGE"
            },
            {
                type: 5,
                title: "CASH_IN.NOTIFICATIONS.TEMPLATES.CHANGE_EMAIL.TITLE",
                message: "CASH_IN.NOTIFICATIONS.TEMPLATES.CHANGE_EMAIL.MESSAGE"
            },
            {
                type: 6,
                title: "CASH_IN.NOTIFICATIONS.TEMPLATES.CARD_FEE.TITLE",
                message: "CASH_IN.NOTIFICATIONS.TEMPLATES.CARD_FEE.MESSAGE"
            },
            {
                type: 7,
                title: "CASH_IN.NOTIFICATIONS.TEMPLATES.BILLET_ISSUED.TITLE",
                message: "CASH_IN.NOTIFICATIONS.TEMPLATES.BILLET_ISSUED.MESSAGE"
            },
            {
                type: 8,
                title: "CASH_IN.NOTIFICATIONS.TEMPLATES.BILLET_PAYED.TITLE",
                message: "CASH_IN.NOTIFICATIONS.TEMPLATES.BILLET_PAYED.MESSAGE"
            },
            {
                type: 9,
                title: "CASH_IN.NOTIFICATIONS.TEMPLATES.PAYMENT_LINK_ISSUED.TITLE",
                message: "CASH_IN.NOTIFICATIONS.TEMPLATES.PAYMENT_LINK_ISSUED.MESSAGE"
            },
            {
                type: 10,
                title: "CASH_IN.NOTIFICATIONS.TEMPLATES.PAYMENT_LINK_PAYED.TITLE",
                message: "CASH_IN.NOTIFICATIONS.TEMPLATES.PAYMENT_LINK_PAYED.MESSAGE"
            },
            {
                type: 11,
                title: "CASH_IN.NOTIFICATIONS.TEMPLATES.SALES_CREDIT.TITLE",
                message: "CASH_IN.NOTIFICATIONS.TEMPLATES.SALES_CREDIT.MESSAGE"
            },
            {
                type: 12,
                title: "CASH_IN.NOTIFICATIONS.TEMPLATES.MOBILE_RECHARGE.TITLE",
                message: "CASH_IN.NOTIFICATIONS.TEMPLATES.MOBILE_RECHARGE.MESSAGE"
            },
            {
                type: 13,
                title: "CASH_IN.NOTIFICATIONS.TEMPLATES.CARD_ISSUE.TITLE",
                message: "CASH_IN.NOTIFICATIONS.TEMPLATES.CARD_ISSUE.MESSAGE"
            }
        ];
        this.loadKey();
    }
    getTemplateByType(data) {
        return this.notificationTemplates.find((template) => {
            return template.type === data.type;
        });
    }
    getMappedNotification(data) {
        const template = this.getTemplateByType.call(this, data);
        return ({
            template,
            params: Object.assign({}, data),
            date: data.date
        });
    }
    mapNotificationDataToTemplate(notificationData) {
        if (Array.isArray(notificationData)) {
            return notificationData.map(this.getMappedNotification.bind(this));
        }
        return this.getMappedNotification.call(this, notificationData);
    }
    getNotificationData(uuidAccount) {
        return this.speNAccountProxy.getNotificationData(uuidAccount);
    }
    getNotification(uuidAccount) {
        let notifications = this.speNAccountProxy.getNotifications(uuidAccount);
        /*     this.speNAccountProxy
              .getNotifications(this.keyPreAccount)
              .subscribe(
                data => {
                  notifications = data;
                },
                err => this.errorMessageService.getError(err)
              ); */
        return notifications;
    }
    confirmReading(notification, uuidAccount) {
        const notifications = this.prepareNotification(notification);
        return this.speNAccountProxy.confirmReading(uuidAccount, notifications);
    }
    prepareNotification(notification) {
        notification = [
            {
                "title": "Confirmação de TED",
                "message": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries",
                "date": "2020-06-02T16:29:26.809Z",
                "read": true
            },
            {
                "title": "Confirmação de Pagamento",
                "message": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries",
                "date": "2020-06-02T16:29:26.809Z",
                "read": true
            }
        ];
        return notification;
    }
};
NotificationsService.ctorParameters = () => [
    { type: SpeNAccountProxy },
    { type: Storage },
    { type: ConfigService },
    { type: ErrorMessageService }
];
NotificationsService = __decorate([
    Injectable()
], NotificationsService);

let AccountRechargeService = class AccountRechargeService {
    constructor(errorMessageService, formBuilder, speJCashInProxy, speJCheckEventProxy) {
        this.errorMessageService = errorMessageService;
        this.formBuilder = formBuilder;
        this.speJCashInProxy = speJCashInProxy;
        this.speJCheckEventProxy = speJCheckEventProxy;
        this.behaviourRecharge = new BehaviorSubject(null);
        this.errorMessages = {
            valueField: [
                { type: 'required', message: 'CASH_IN.ACCOUNT_RECHARGE.FORM.VALUE_FIELD.MESSAGE.REQUIRED' },
                {
                    type: 'min',
                    message: 'CASH_IN.ACCOUNT_RECHARGE.FORM.VALUE_FIELD.MESSAGE.MIN',
                    param: { min: 20 },
                },
            ],
        };
    }
    getErrorAccountRecharge(error) {
        this.errorMessageService.getError(error);
    }
    getFormErrorMessage() {
        return this.errorMessages;
    }
    saveValue(data) {
        this.behaviourRecharge.next(data);
    }
    getValue() {
        return this.behaviourRecharge;
    }
    unSubscribe() {
        this.behaviourRecharge = new BehaviorSubject(null);
    }
    getRechargeData() {
        this.formRecharge = this.formBuilder.group({
            valueField: new FormControl('', Validators.compose([Validators.required])),
        });
        return this.formRecharge;
    }
    // generateBillet(rechargeValue: number, accountData: any): RechargeBilletResponse {
    //   // await this.loadKey()
    //   return this.SpeNRechargeBilletProxy.generateBillet(rechargeValue, accountData);
    // }
    generateBillet(value, uuidAccountPaymet, uuidWhitelabel) {
        return this.speJCashInProxy.generateBillet(value, uuidAccountPaymet, uuidWhitelabel);
    }
    getBilletsByUuidAccountPayment(uuidAccountPayment) {
        return this.speJCashInProxy.getBilletsByUuidAccountPayment(uuidAccountPayment);
    }
    getBilletsByUuidAccountPaymentAndType(uuidAccountPayment, type) {
        return this.speJCashInProxy.getBilletsByUuidAccountPaymentAndType(uuidAccountPayment, type);
    }
    getBilletsByUuidAccountPaymentAndFinished(uuidAccountPayment, isFinished, dateInitial, dateEnd) {
        return this.speJCashInProxy.getBilletsByUuidAccountPaymentAndFinished(uuidAccountPayment, isFinished, dateInitial, dateEnd);
    }
    getBilletsByUuidAccountPaymentAndPeriod(uuidAccountPayment, dateInitial, dateEnd) {
        return this.speJCashInProxy.getBilletsByUuidAccountPaymentAndPeriod(uuidAccountPayment, dateInitial, dateEnd);
    }
    getBilletsByUuidAccountPaymentAndPeriodAndType(uuidAccountPayment, type, dateInitial, dateEnd) {
        return this.speJCashInProxy.getBilletsByUuidAccountPaymentAndPeriodAndType(uuidAccountPayment, type, dateInitial, dateEnd);
    }
    getBilletsByUuid(uuid) {
        return this.speJCashInProxy.getBilletsByUuid(uuid);
    }
    getBilletsByTransactionId(transactionId) {
        return this.speJCashInProxy.getBilletsByTransactionId(transactionId);
    }
    validateOperation(uuidWhiteLabel, uuidAccount, valueBillet) {
        return __awaiter(this, void 0, void 0, function* () {
            let sendingBody;
            let validateResponse;
            sendingBody = {
                codeOperation: '1001',
                uuidAccountPayment: uuidAccount,
                uuidWhiteLabel: uuidWhiteLabel,
                valueOperation: this.formatValue(valueBillet),
            };
            yield this.speJCheckEventProxy
                .validateOperation(sendingBody)
                .toPromise()
                .then((res) => {
                validateResponse = res;
            })
                .catch((err) => this.getErrorAccountRecharge(err));
            let response = !!validateResponse ? validateResponse : null;
            return Promise.resolve(response);
        });
    }
    /**
     * @description Método fomata o valor de string e retorna um float
     */
    formatValue(value) {
        let billetValue = value.replace(/\./g, '');
        let billetValue2 = billetValue.replace(',', '.');
        return parseFloat(billetValue2);
    }
};
AccountRechargeService.ctorParameters = () => [
    { type: ErrorMessageService },
    { type: FormBuilder },
    { type: SpeJCashInProxy },
    { type: SpeJCheckEventProxy }
];
AccountRechargeService = __decorate([
    Injectable()
], AccountRechargeService);

let BilletService = class BilletService {
    constructor(speJCashInProxy, speJCheckEventProxy, speViewNAccountProxy, errorMessageService) {
        this.speJCashInProxy = speJCashInProxy;
        this.speJCheckEventProxy = speJCheckEventProxy;
        this.speViewNAccountProxy = speViewNAccountProxy;
        this.errorMessageService = errorMessageService;
        this.behaviourBillet = new BehaviorSubject(null);
    }
    saveValue(data) {
        this.behaviourBillet.next(data);
    }
    getValue() {
        return this.behaviourBillet;
    }
    unSubscribe() {
        this.behaviourBillet = new BehaviorSubject(null);
    }
    generateBillet(body) {
        return this.speJCashInProxy.generateBilletWithObject(body);
    }
    getBilletsByUuidAccountPayment(uuidAccountPayment, type) {
        return this.speJCashInProxy.getBilletsByUuidAccountPaymentAndType(uuidAccountPayment, type);
    }
    getBilletsByUuidAccountPaymentAndFinished(uuidAccountPayment, isFinished, dateInitial, dateEnd) {
        return this.speJCashInProxy.getBilletsByUuidAccountPaymentAndFinished(uuidAccountPayment, isFinished, dateInitial, dateEnd);
    }
    getBilletsByUuidAccountPaymentAndPeriod(uuidAccountPayment, type, dateInitial, dateEnd) {
        return this.speJCashInProxy.getBilletsByUuidAccountPaymentAndPeriodAndType(uuidAccountPayment, type, dateInitial, dateEnd);
    }
    getBilletsByUuid(uuid) {
        return this.speJCashInProxy.getBilletsByUuid(uuid);
    }
    getAllStatusDataByStatus(uuidAccountPayment, type, status, dateInitial, dateEnd) {
        return this.speJCashInProxy.getAllStatusDataByStatus(uuidAccountPayment, type, status, dateInitial, dateEnd);
    }
    getBilletsByTransactionId(transactionId) {
        return this.speJCashInProxy.getBilletsByTransactionId(transactionId);
    }
    getBilletCreateTax(uuidWhiteLabel, uuidAccountPayment, codeOperation) {
        return __awaiter(this, void 0, void 0, function* () {
            let taxResponse;
            yield this.speViewNAccountProxy.getCardTax(uuidWhiteLabel, uuidAccountPayment, codeOperation)
                .toPromise()
                .then(res => {
                taxResponse = res;
            })
                .catch(err => this.getError(err));
            let response = !!taxResponse ? taxResponse : null;
            return Promise.resolve(response);
        });
    }
    validateOperation(uuidWhiteLabel, uuidAccount, valueBillet) {
        return __awaiter(this, void 0, void 0, function* () {
            let sendingBody;
            let validateResponse;
            sendingBody = {
                codeOperation: '1002',
                uuidAccountPayment: uuidAccount,
                uuidWhiteLabel: uuidWhiteLabel,
                valueOperation: this.formatValue(valueBillet),
            };
            yield this.speJCheckEventProxy.validateOperation(sendingBody)
                .toPromise()
                .then(res => {
                validateResponse = res;
            })
                .catch(err => console.error(err));
            let response = !!validateResponse ? validateResponse : null;
            return Promise.resolve(response);
        });
    }
    /**
     * @description Método fomata o valor de string e retorna um float
     */
    formatValue(value) {
        let billetValue = value.replace(/\./g, '');
        let billetValue2 = billetValue.replace(',', '.');
        return parseFloat(billetValue2);
    }
    getError(error) {
        this.errorMessageService.getError(error);
    }
};
BilletService.ctorParameters = () => [
    { type: SpeJCashInProxy },
    { type: SpeJCheckEventProxy },
    { type: SpeViewNAccountProxy },
    { type: ErrorMessageService }
];
BilletService = __decorate([
    Injectable()
], BilletService);

let ChargingService = class ChargingService extends BaseService {
    constructor(storage, configService, formBuilder) {
        super(storage, configService);
        this.storage = storage;
        this.configService = configService;
        this.formBuilder = formBuilder;
        this.errorMessages = {
            document: [
                {
                    type: 'required',
                    message: 'CASH_OUT.ACCOUNT_CHARGING.FORM.VALUE_FIELD.MESSAGE.REQUIRED',
                },
                {
                    type: 'cnpjNotValid',
                    message: 'CASH_OUT.ACCOUNT_CHARGING.FORM.VALUE_FIELD.MESSAGE.CNPJ_NOT_VALID',
                },
                {
                    type: 'cpfNotValid',
                    message: 'CASH_OUT.ACCOUNT_CHARGING.FORM.VALUE_FIELD.MESSAGE.CPF_NOT_VALID',
                },
            ],
            nameComplete: [
                {
                    type: 'required',
                    message: 'CASH_OUT.ACCOUNT_CHARGING.FORM.VALUE_FIELD.MESSAGE.REQUIRED',
                },
            ],
            email: [
                {
                    type: 'required',
                    message: 'CASH_OUT.ACCOUNT_CHARGING.FORM.VALUE_FIELD.MESSAGE.REQUIRED',
                },
                {
                    type: 'minlength',
                    message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.E_MAIL.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 },
                },
                {
                    type: 'maxlength',
                    message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.E_MAIL.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 60 },
                },
                { type: 'pattern', message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.E_MAIL.MESSAGE.PATTERN' },
            ],
            billetValue: [
                {
                    type: 'required',
                    message: 'CASH_OUT.ACCOUNT_CHARGING.FORM.VALUE_FIELD.MESSAGE.REQUIRED',
                },
            ],
            descripiton: [
                {
                    type: 'required',
                    message: 'CASH_OUT.ACCOUNT_CHARGING.FORM.VALUE_FIELD.MESSAGE.REQUIRED',
                },
            ],
            dateDue: [
                { type: 'required', message: 'CASH_OUT.ACCOUNT_CHARGING.FORM.VALUE_FIELD.MESSAGE.REQUIRED' },
                {
                    type: 'validDateAfter',
                    message: 'CASH_OUT.ACCOUNT_CHARGING.FORM.VALUE_FIELD.MESSAGE.DATE_NOT_VALID_AFTER',
                    param: { dateAfter: 3 },
                },
                {
                    type: 'ptDate',
                    message: 'CASH_OUT.ACCOUNT_CHARGING.FORM.VALUE_FIELD.MESSAGE.DATE_NOT_VALID',
                },
            ],
            billetBodyObservations: [
                {
                    type: 'maxlength',
                    message: 'CASH_OUT.ACCOUNT_CHARGING.FORM.VALUE_FIELD.MESSAGE.MAX_LENGTH',
                    param: {
                        maxLength: 120,
                    },
                },
            ],
            orderNumber: [
                {
                    type: 'maxlength',
                    message: 'CASH_OUT.ACCOUNT_CHARGING.FORM.VALUE_FIELD.MESSAGE.MAX_LENGTH',
                    param: {
                        maxLength: 20,
                    },
                },
            ],
        };
    }
    createFormEmitBillet() {
        this.billetChargingForm = this.formBuilder.group({
            document: new FormControl('', Validators.compose([Validators.required, DocumentValidator.isValidCPFCNPJ, Validators.minLength(14)])),
            nameComplete: new FormControl('', Validators.compose([Validators.required])),
            billetValue: new FormControl('', Validators.compose([Validators.required])),
            descripiton: new FormControl('', Validators.compose([Validators.maxLength(200)])),
            billetBodyObservations: new FormControl('', Validators.compose([Validators.maxLength(120)])),
            orderNumber: new FormControl('', Validators.compose([Validators.maxLength(20), Validators.pattern('^[A-Za-z0-9-]*$')])),
            dateDue: new FormControl('', Validators.compose([Validators.required, DateValidator.validDateAfter, DateValidator.ptDate])),
            email: new FormControl('', Validators.compose([
                Validators.minLength(6),
                Validators.maxLength(60),
                Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,5}'),
            ])),
        });
        return this.billetChargingForm;
    }
    disabledToogle(billetChargingForm) {
        return billetChargingForm.controls.document.valid && billetChargingForm.controls.name.valid;
    }
    getErrorMessages() {
        return this.errorMessages;
    }
};
ChargingService.ctorParameters = () => [
    { type: Storage },
    { type: ConfigService },
    { type: FormBuilder }
];
ChargingService = __decorate([
    Injectable()
], ChargingService);

let QrcodeOnusService = class QrcodeOnusService extends BaseService {
    constructor(storage, configService, formBuilder, speNAccountsProxy) {
        super(storage, configService);
        this.storage = storage;
        this.configService = configService;
        this.formBuilder = formBuilder;
        this.speNAccountsProxy = speNAccountsProxy;
    }
    getFormMessageError() {
        return {
            value: [
                { type: 'required', message: 'QRCODE_ON_US.INTRO.INPUT.ERROR' },
            ]
        };
    }
    createFormTransfer() {
        return this.formBuilder.group({
            value: new FormControl('', Validators.compose([
                Validators.required,
            ]))
        });
    }
    generateQrcode(uuidAccountPayment, value) {
        return this.speNAccountsProxy.generateQrcode(uuidAccountPayment, Number(value.replaceAll('.', '').replace(',', '.')));
    }
    statusQrcode(encode) {
        return this.speNAccountsProxy.statusQrcode(encode);
    }
};
QrcodeOnusService.ctorParameters = () => [
    { type: Storage },
    { type: ConfigService },
    { type: FormBuilder },
    { type: SpeNAccountsProxy }
];
QrcodeOnusService = __decorate([
    Injectable()
], QrcodeOnusService);

var UiBsCashInModule_1;
let UiBsCashInModule = UiBsCashInModule_1 = class UiBsCashInModule {
    constructor(parentModule) {
        //.....
    }
    static forRoot(config) {
        return {
            ngModule: UiBsCashInModule_1,
            providers: [
                { provide: APP_PARAMETER, useValue: config }
            ]
        };
    }
};
UiBsCashInModule.ctorParameters = () => [
    { type: UiBsCashInModule, decorators: [{ type: Optional }, { type: SkipSelf }] }
];
UiBsCashInModule = UiBsCashInModule_1 = __decorate([
    NgModule({
        imports: [
            CommonModule,
            FormsModule,
            IonicModule,
            IonicStorageModule.forRoot({
                driverOrder: ['indexeddb', 'sqlite', 'websql']
            }),
            UiPxCashInModule,
            UiBsUtilModule,
            RxReactiveFormsModule
        ],
        providers: [
            AccountBalanceService,
            NotificationsService,
            AccountRechargeService,
            StatementService,
            BilletService,
            ChargingService,
            QrcodeOnusService
        ],
        exports: [RxReactiveFormsModule]
    }),
    __param(0, Optional()), __param(0, SkipSelf())
], UiBsCashInModule);

let AccountShareService = class AccountShareService {
    constructor() {
    }
};
AccountShareService = __decorate([
    Injectable()
], AccountShareService);

class AccountBalanceResponse {
}

class AccountPaymentRechargeBilletResponse {
}

class AccountShareResponse {
}

class NotificationsResponse {
}

class RechargeBilletResponse {
}

var BilletTypeEnum;
(function (BilletTypeEnum) {
    BilletTypeEnum["RECHARGE"] = "RECHARGE";
    BilletTypeEnum["CHARGING"] = "CHARGING";
})(BilletTypeEnum || (BilletTypeEnum = {}));

var BilletStatusEnum;
(function (BilletStatusEnum) {
    BilletStatusEnum["CANCELED"] = "CANCELED";
    BilletStatusEnum["PENDING"] = "PENDING";
    BilletStatusEnum["COMPENSATED"] = "COMPENSATED";
})(BilletStatusEnum || (BilletStatusEnum = {}));

/*
 * Public API Surface of ui-bs-cashin
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AccountBalanceResponse, AccountBalanceService, AccountPaymentRechargeBilletResponse, AccountRechargeService, AccountShareResponse, AccountShareService, BilletService, BilletStatusEnum, BilletTypeEnum, ChargingService, NotificationsResponse, NotificationsService, QrcodeOnusService, RechargeBilletResponse, StatementService, UiBsCashInModule };
//# sourceMappingURL=wlp-ui-bs-cashin.js.map
